/**
 * ProductRecommendations is a custom HTMLElement that fetches and displays product recommendations.
 * On being attached to the DOM, it makes a fetch request to a provided URL (from dataset.url),
 * retrieves the product recommendations, and populates its own content with those recommendations.
 */
class ProductRecommendations extends window.HTMLElement {
  connectedCallback() {
    if (!this.dataset.url === undefined) {
      console.error('Product recommendations URL missing.')
      return
    }

    fetch(this.dataset.url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`)
        }
        return response.text()
      })
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('product-recommendations')

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML
        }
      })
      .catch((e) => {
        console.error('Error fetching product recommendations:', e)
      })
  }
}

// Register the custom element 'product-recommendations'
window.customElements.define('product-recommendations', ProductRecommendations)
